<template>
  <b-modal
    v-model="open"
    aria-label="Common Modal"
    aria-modal
    aria-role="dialog"
    destroy-on-hide
    has-modal-card
    trap-focus
    :width="width"
    :on-cancel="close"
    :can-cancel="canCancel"
    @after-leave="close"
  >
    <div class="modal-card">
      <header
        v-if="showHeader"
        class="
          has-text-white
          is-flex
          is-align-items-center
          modal-card__header
          px-5
          py-4
        "
        :class="`has-background-${type}`"
      >
        <section class="has-text-centered modal-card__header--main">
          <slot name="header" />
        </section>
        <b-button
          v-if="showHeaderClose"
          class="modal-card__header--close-btn"
          type="is-ghost"
          @click="close"
        >
          <i class="icon-cross" />
        </b-button>
      </header>
      <section
        :class="[contentPadding]"
        :style="{ width: typeof width === 'string' ? width : `${width}px` }"
        class="modal-content bg-white modal-card__content"
        ref="contentRef"
      >
        <slot name="content" />
      </section>
      <footer
        v-if="showFooter"
        class="
          has-background-white
          is-flex
          is-align-items-center
          is-justify-content-end
          modal-card__footer
          py-4
          px-5
        "
      >
        <slot name="footer" />
      </footer>
    </div>
  </b-modal>
</template>

<script>
import WModal from './WModal';

export default WModal;
</script>

<style lang="scss" scoped>
@import 'WModal';
</style>
